import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { App } from "./App";
import { initTelegram } from "./lib/telegram";
import "./styles/theme.css";
import "./styles/app.css";
import "./styles/pages.css";
import "./styles/order.css";
import "./styles/onboarding.css";
import "./styles/profile-fields.css";
import "./styles/articles.css";

initTelegram();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Mini App часто сворачивают и разворачивают — рефетч на каждый фокус
      // означал бы шквал запросов на мобильной сети.
      refetchOnWindowFocus: false,
      staleTime: 30_000,
      retry: 1,
    },
  },
});

const root = document.getElementById("root");
if (!root) throw new Error("Не найден #root");

createRoot(root).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>,
);
